/**
 * 移动端适配公共功能
 * isMobile 判断是否是移动端
 */
export default {
  data() {
    return {
      // 屏幕窗口宽度
      screenWidth: document.documentElement.clientWidth
    }
  },
  computed: {
    isMobile() {
      // 屏幕宽度小于等于800px则使用移动端适配
      return this.screenWidth <= 800
    }
  },
  mounted() {
    // 窗口大小改变
    window.onresize = () => {
      this.screenWidth = document.documentElement.clientWidth
    }
  }
}
